const StageComponent = ({ title = "", positionTitle = "top", img = "" }) => {
    const position = {
        top: "stage__title--top",
        bottom: "stage__title--bottom"
    }

    return (
        <section className="stage">
            <h1 className={`stage__title ${position[positionTitle]}`}>{title}</h1>
            <img className='stage__image' src={img} alt="Audi Banner" />
        </section>
    );
}

export default StageComponent;